import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';
import { posts } from '../data/blogPosts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <main className="bg-[#05050A] min-h-screen">
      <section className="relative pt-32 pb-12 overflow-hidden">
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-purple-600/15 rounded-full blur-[120px] pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/blog" data-testid="blog-back" className="inline-flex items-center gap-1.5 text-xs text-white/45 hover:text-white transition-colors mb-8">
            <ArrowLeft size={12} /> Back to all notes
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <span className="text-[10px] font-outfit font-semibold text-purple-300 tracking-[0.2em] uppercase">{post.category}</span>
            <span className="text-white/20">·</span>
            <span className="flex items-center gap-1 text-[10px] text-white/40"><Clock size={10} /> {post.readTime}</span>
          </div>
          <h1 className="font-outfit font-black text-4xl sm:text-5xl text-white tracking-tight leading-[1.05] mb-6">
            {post.title}
          </h1>
          <p className="text-white/60 text-base sm:text-lg leading-relaxed">
            {post.excerpt}
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`h-1.5 w-24 rounded-full bg-gradient-to-r ${post.accent} mb-10`} />
          <article className="space-y-10">
            {post.sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-outfit font-bold text-white text-xl sm:text-2xl mb-3 tracking-tight">{s.heading}</h2>
                <div className="space-y-3">
                  {s.body.map((para, j) => (
                    <p key={j} className="text-white/60 text-[15px] leading-relaxed">{para}</p>
                  ))}
                </div>
              </div>
            ))}
          </article>

          <div className="mt-16 pt-8 border-t border-white/8 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <Link to="/blog" data-testid="blog-bottom-back" className="inline-flex items-center gap-1.5 text-sm text-white/50 hover:text-white transition-colors">
              <ArrowLeft size={13} /> All notes
            </Link>
            <Link to="/testing" data-testid="blog-testing-cta" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold bg-white/5 border border-white/15 text-white hover:bg-white/10 hover:border-purple-400/40 transition-all">
              Join the testing program
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BlogPost;
